import { inject, Injectable } from '@angular/core';
import { getState } from '@ngrx/signals';
import { TransactionSuccessStore } from './transaction-success.store';

@Injectable({ providedIn: 'root' })
export class TransactionSuccessQuery {
  public readonly store = inject(TransactionSuccessStore);

  getValue() {
    return getState(this.store);
  }
}
